import { createFileRoute, Outlet } from '@tanstack/react-router';

export const Route = createFileRoute('/_dashboard/courses')({
  component: RouteComponent,
  loader: () => ({
    crumb: 'Courses',
  }),
});

function RouteComponent() {
  return <Outlet />;
}
